import { UserStore } from "./UserStore";

// The one piece of state genuinely shared between Swageazy Commander and
// Swayy Commander: the logged-in admin's session. Both projects' store
// registries merge this same singleton in so `useStores().userStore` /
// `useSwayyStores().userStore` refer to the identical instance.
export const userStore = new UserStore();
